import { render, staticRenderFns } from "./GLCodeMappingPolicyGrid.vue?vue&type=template&id=5a8ffa52"
import script from "./GLCodeMappingPolicyGrid.vue?vue&type=script&lang=js"
export * from "./GLCodeMappingPolicyGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports